import {
  Grid,
  LinearProgress,
  Card,
  CardContent,
  CircularProgress,
  Button,
} from "@mui/material";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";
import { Reports } from "../../../../../app/slices/reportsSlice";

const TotalsTable = () => {
  const dispatch = useDispatch();

  const _Totals = useSelector((state) => state.reports.totals);
  const loading = useSelector((state) => state.reports.reports.loading);
  const _Role = useSelector((state) => state.user.userInfo.user_roles[0]);
  const _UserInfo = useSelector((state) => state.user.userInfo);
  const PRIVILEGED_USER_ID = "aba4cd5e-7d97-43c9-b287-5cd6a4d566d7";

  const columns = [
    {
      field: "name",
      headerName: "الاسم",
      flex: 1,
    },
    {
      field: "amount",
      headerName: "المبلغ (IQD)",
      flex: 1,
    },
  ];

  var rows = [
    {
      id: 1,
      name: "مبلغ الكودات المتوفرة",
      amount: _Totals?.total_pins?.toLocaleString(),
    },
    {
      id: 2,
      name: "مبلغ خزنة الكاش",
      amount: _Totals?.total_cash?.toLocaleString(),
    },
    {
      id: 3,
      name: "مبلغ كاش المندوبين",
      amount: _Totals?.total_rep_cash?.toLocaleString(),
    },
    {
      id: 6,
      name: "مجموع ديون نقاط البيع",
      amount: _Totals?.total_pos_rep_debt?.toLocaleString(),
    },
    {
      id: 5,
      name: "مجموع رصيد نقاط البيع",
      amount: _Totals?.total_pos_rep_balance?.toLocaleString(),
    },
    {
      id: 8,
      name: "مجموع رصيد الموردين",
      amount: _Totals?.total_supplier?.toLocaleString(),
    },
    {
      id: 14,
      name: "مجموع رصيد الممولين",
      amount: _Totals?.total_investors?.toLocaleString(),
    },
    {
      id: 9,
      name: "مجموع رصيد المجهزين",
      amount: _Totals?.product_supplier_balance?.toLocaleString(),
    },
    {
      id: 15,
      name: "مجموع رصيد العملاء",
      amount: _Totals?.total_client_cash?.toLocaleString(),
    },
    {
      id: 13,
      name: " رصيد التحويل المتوفر",
      amount: _Totals?.total_sim_card_balance?.toLocaleString(),
    },
    {
      id: 4,
      name: "مجموع الارباح",
      amount: _Totals?.total_revenue?.toLocaleString(),
    },
    {
      id: 11,
      name: "مجموع ارباح المنصة",
      amount: _Totals?.product_supplier_wages?.toLocaleString(),
    },
    {
      id: 12,
      name: "مجموع ارباح التحويل",
      amount: _Totals?.total_transfer_revenue?.toLocaleString(),
    },
    {
      id: 16,
      name: "كاش العملاء",
      amount: _Totals?.total_client_cash?.toLocaleString(),
    },
    {
      id: 17,
      name: "رصيد العملاء",
      amount: _Totals?.total_pos_client_balance?.toLocaleString(),
    },
    {
      id: 18,
      name: "ديون العملاء",
      amount: _Totals?.total_pos_client_debt?.toLocaleString(),
    },
    {
      id: 19,
      name: "الديون العامة",
      amount: _Totals?.total_global_debt?.toLocaleString(),
    },
    {
      id: 10,
      name: "الناتج",
      amount: _Totals.result
        // (_Totals?.total_pins || 0) +
        // (_Totals?.total_rep_cash || 0) +
        // (_Totals?.total_cash || 0) -
        // (_Totals?.total_revenue || 0) -
        // (_Totals?.total_pos_balance || 0) +
        // (_Totals?.total_pos_debt || 0) -
        // (_Totals?.total_supplier || 0) -
        // (_Totals?.product_supplier_balance || 0) -
        // (_Totals?.product_supplier_wages || 0) -
        // (_Totals?.total_transfer_revenue || 0) +
        // (_Totals?.total_sim_card_balance || 0) -
        // (_Totals?.total_investors || 0)
        ?.toLocaleString(),
    },
  ];

  rows =
    _Role !== "super_admin"
      ? rows.filter(
          (row) =>
            row.id !== 4 && row.id !== 11 && row.id !== 10 && row.id !== 12,
        )
      : rows;

  rows =
    _UserInfo.id === PRIVILEGED_USER_ID
      ? rows.filter(
          (row) =>
            row.id !== 1 &&
            row.id !== 3 &&
            row.id !== 2 &&
            row.id !== 8 &&
            row.id !== 14 &&
            row.id !== 9 &&
            row.id !== 16,
        )
      : rows;

  const handleSearch = () => {
    dispatch(Reports.totals());
  };

  return (
    <Card>
      <CardContent>
        <Grid container rowSpacing={1} columnSpacing={2}>
          <Grid item xs={12} sx={{ mb: 2 }}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSearch}
              disabled={loading}
            >
              بحث
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Box sx={{ height: "70vh", width: "100%" }}>
              {_Totals ? (
                <DataGrid
                  sx={{
                    ".total-amount": {
                      fontWeight: "bold",
                      bgcolor: "#e0e0e0",
                      "&:hover": {
                        bgcolor: "#e0e0e0",
                      },
                    },
                  }}
                  rows={rows}
                  columns={columns}
                  loading={loading}
                  pageSize={100}
                  rowHeight={40}
                  selectionModel={[]}
                  getRowClassName={(params) => {
                    return params.row.id === 10 ? "total-amount" : "";
                  }}
                  components={{
                    LoadingOverlay: LinearProgress,
                  }}
                />
              ) : (
                <CircularProgress />
              )}
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default TotalsTable;
